import { loginGoogle } from "../../services/google"
import { authGooglePayload } from "../../interfaces/google"
import { toast } from "react-toastify"
import { io } from "socket.io-client"

const AuthGoogle = async ({ idOrganizacao, email, tokens, isAuth, navigate }: authGooglePayload) => {

    try {

        const payload = {
            idOrganizacao,
            tokens,
            email
        }

        const resposta = await toast.promise(loginGoogle(payload), {
            pending: 'Validando Suas Credenciais, aguarde!',
            success: 'Autenticação Bem Sucessida'
        })

        if (resposta.status === 200) {

            const data = new Date()
            const validadeToken = new Date (data.getTime() + 60 * 60 * 4 * 1000)
    
            const token = resposta.data.token;
            document.cookie = `authGesttor=${token}; expires=true ${validadeToken.toUTCString()}`
    
            localStorage.setItem("perfilGesttor", `${resposta.data.perfil}`)
            localStorage.setItem('usuarioGesttor', `${resposta.data.id}`)
            localStorage.setItem("organizacaoGesttor", `${resposta.data.idOrganizacao}`)
            localStorage.setItem("usuarioGesttorAvatar", `${resposta.data.avatar}`)
            localStorage.setItem("organizacaoGesttorAvatar", `${resposta.data.avatarOrganizacao}`)
            localStorage.setItem('authGesttor', 'true')
            localStorage.setItem("permissao", resposta.data.permissoes)

            const organizacao = resposta.data.idOrganizacao
            const usuario = resposta.data.id
    
            const socket = io(`${process.env.REACT_APP_API_GESTTOR}?idOrganizacao=${organizacao}`)
    
            const mensagemDados = {
              usuario
            }
    
            socket.emit('notificacaoUsuario', organizacao, mensagemDados)
    
            isAuth()
            
            
            return navigate("/tarefas")
        }
        
    } catch (error: any) {

        if (error.response.status === 401) {
            return toast.error('Credenciais não Validadas. Tente Novamente')
        }

        if (error.response.status === 408) {
            return toast.error('Licença Expirada. Fale com o nosso Atendimento')
        }
    
        if (error.response.status === 0) {
            return toast.error('Servidor Indisponível. Tente Novamente Mais Tarde')
        }
    
        if (error.response.status === 403) {
            return toast.error('Acesso Negado. Fale com o administrador da sua empresa para liberar o acesso')
        }

        if (error.response.status === 500) {
            return toast.error('Falha ao Processar a sua Solicitação')
        }
        
    }
}

export {
    AuthGoogle
}